<template>
	<div class="flex flex-col" :class="fullscreen ? 'c-box-fullscreen' : 'c-box'" @click.stop>
		<div :class="fullscreen ? 'header-box-fullscreen' : 'header-box'">
			<p style="width: 90%; margin: 0 auto" v-if="this.$store.state.region != '5'" :title="preViewData.name"
				class="nowrap">
				{{ preViewData.name || preViewData.principals }}
			</p>
			<p style="width: 90%; margin: 0 auto" v-else :title="preViewData.zpname" class="nowrap">
				{{ preViewData.zpname }}
			</p>
			<div class="fullScreen" @click="goNewPage()">
				<div class="iconfont icon-style" v-if="fullscreen">&#xe749;</div>
				<div class="iconfont icon-style" v-else>&#xe60f;</div>
			</div>
			<div class="close-box" @click="closePreview">×</div>
		</div>
		<div class="centent-box flex-1 flex">
			<!---->
			<div class="left-preview-box flex-1">
				<!-- 仅展示视频模式下的无视频空状态 -->
				<div style="height: 100%; position: relative"
					v-if="videoOnly && videoEmpty">
					<div class="flex flex-col align-items-center" style="
			              position: absolute;
			              top: 50%;
			              left: 50%;
			              transform: translate(-50%, -50%);
			            ">
						<div>
							<img style="width: 50%; height: 50%; margin: 0 auto; display: block"
								src="~@/assets/images/img55.png" alt="" />
						</div>
						<div style="margin-top: 20px; font-size: 18px">
							暂无教学视频
						</div>
					</div>
				</div>
				<!-- 空状态 -->
				<div style="height: 100%; position: relative"
					v-if="previewType === '' && defaultGraph === false && !ishow && emptyPrompt">
					<div class="flex flex-col align-items-center" style="
			              position: absolute;
			              top: 50%;
			              left: 50%;
			              transform: translate(-50%, -50%);
			            ">
						<div>
							<img style="width: 50%; height: 50%; margin: 0 auto; display: block"
								src="~@/assets/images/img55.png" alt="" />
						</div>
						<div style="margin-top: 20px; font-size: 18px">
							点击右侧文件查看
						</div>
					</div>
				</div>
				<!-- pdf 格式 -->
				<div class="pdf-wrap" :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
					v-if="((previewType.toLowerCase() === 'pdf' || previewType === 'doc' || (previewType === 'docx' && defaultGraph === false)) && previewType.toLowerCase()!='mp4' && !ishow && reviewShow === false)">
					<iframe ref="iframe" width="100%" :src="previewUrl" name="123" scrolling-y="auto" frameborder="0"
						style="width: 100%; height: 100%; background: #fff"></iframe>
				</div>
				<div class="pdf-wrap" :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
					style="background-color: #fff;" v-if="ishow && reviewShow === false">
					<div style="width: 100%; height: 100%; background: #fff;overflow:auto;">
						<basic-data :editInfoStep1="editInfoStep1"></basic-data>
					</div>
				</div>
				<!-- jpg png bmp 图片格式 -->
				<div :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'" v-if="previewType === 'jpg' ||
					previewType === 'png' ||
					previewType === 'jpeg' ||
					(previewType === 'bmp' && defaultGraph === false && !ishow && reviewShow === false)
					">
					<img class="img-preview" :src="previewUrl" alt="" />
				</div>
				<!-- mp4 视频格式 -->
				<div :class="fullscreen ? 'img-preview-box-fullscreen' : 'img-preview-box'"
					v-if="previewType === 'mp4' || previewType === 'MP4' && !ishow && reviewShow === false">
					<video style="height: 100%; width: 100%" controls controlsList="nodownload" autoplay="autoplay"
						:src="previewUrl"></video>
				</div>


				<!-- 其他视频格式 -->
				<div style="height: 100%; position: relative" v-if="previewType !== '' &&
					previewType !== 'pdf' &&
					previewType !== 'jpg' &&
					previewType !== 'png' &&
					previewType !== 'bmp' &&
					previewType !== 'mp4' &&
					previewType !== 'jpeg' &&
					defaultGraph === false &&
					!ishow && reviewShow === false
					">
					<!--          <a-button type="success" @click="downLoadFile">下载文件预览</a-button>-->
					<div class="flex flex-center flex-col align-items-center">
						<div class="flex flex-col align-items-center" style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              ">
							<div>
								<img style="
                    width: 50%;
                    height: 50%;
                    margin: 0 auto;
                    display: block;
                  " src="~@/assets/images/img55.png" alt="" />
							</div>
							<div style="margin-top: 20px; font-size: 18px">
								<a-button type="button" style="width: 180px; height: 40px; font-size: 16px"
									@click="downLoadFile">
									点击下载
									<!-- <a :href="this.previewUrl" download>点击下载</a> -->
								</a-button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="defaultGraph && !ishow" class="msg-box">
					<div>
						<img style="width: 465px; height: 291px" src="~@/assets/images/img53.png" alt="" />
					</div>
					<div>暂无内容</div>
				</div>


				<!-- 评审表格 -->
				<div id="review-content" class="review-content" v-if="reviewShow">
					<a-table class="table" :columns="columns" :data-source="reviewData.dataList" bordered
						:pagination="false" :rowKey="(record) => record.id">
						<!-- 
		            :scroll="{ x: false, y: 240 }"
		
		           -->
						<span slot="oneTarget" slot-scope="text">{{ text }}</span>
						<template slot="content" slot-scope="text, record">
							<div>
								<span
									style="white-space: pre-line;text-align: left;font-size: 18px;line-height:28px;display: block;">{{
										transform(text) }}</span>
							</div>
						</template>
						<template slot="itemScore" slot-scope="text, record">
							<editable-cell :evaluationTablePreview="evaluationTablePreview" :max="record.score"
								:text="text" @change="onCellChange(record.id, 'itemScore', $event)" />
						</template>
					</a-table>
					<div class="target-score">
						<span>
							指标总分值：
							<span class="number">{{ targetTotalScore }}</span>
							<span class="score">分</span>
						</span>
						<span style="margin-left: 30px">
							总得分：
							<span class="number">{{ totalPoints }}</span>
							<span class="score">分</span>
						</span>
					</div>
					<div class="expertReviews">
						<div class="expertReviews-title">专家评语</div>
						<a-textarea class="remark-input" v-model="reviewData.remark" placeholder="请输入评语~"
							:maxLength="500" :auto-size="{ minRows: 4, maxRows: 6 }" :disabled="evaluationTablePreview"
							@change="remarkChange" />
					</div>
					<div class="submit" @click="submit" v-if="!evaluationTablePreview">提交</div>
				</div>







			</div>
			<div class="right-filelist-box flex flex-col" v-if="!videoOnly">
				<!--  :style="[
            { height: type === 'expert' ? 'auto' : '100%' },
            { 'max-height': type === 'expert' ? '70%' : '' },
          ]" -->
				<div class="top-filelist flex-1">
				<a-tree class="myTree" showLine v-if="fileTreeList && fileTreeList.length" @select="onSelect"
					:defaultSelectedKeys="[fileTreeList[0].key]" :defaultExpandAll="false" :autoExpandParent="false"
					:defaultExpandParent="false" :defaultExpandedKeys="videoOnly ? [1] : []">
						<a-icon style="color: #c73630" slot="switcherIcon" type="down" />
						<a-tree-node style="color: #c73630" v-for="item in fileTreeList" :key="item.key"
							:title="item.title">
							<a-tree-node style="color: #c73630" v-for="item1 in item.children" :key="item.hadThree == false
								? item1.previewPath || item1.filePath
								: item1.key
								" :title="item.hadThree == false
									? getFileName(item1.filePath)
									: item1.title
									">
								<template v-if="item.hadThree == true">
									<a-tree-node style="color: #c73630" v-for="item2 in item1.children" :key="item2.proviewPath ? item2.proviewPath : item2.filePath
										" :title="getFileName(item2.filePath)">
									</a-tree-node>
								</template>
							</a-tree-node>
						</a-tree-node>
					</a-tree>
				</div>
				<div class="bottom-evaluate" v-if="type === 'expert'">
					<!--          <div class="flex" style="margin-bottom: 8px">-->
					<!--            <div>评审模板下载 :</div>-->
					<!--            <div class="flex align-items-center">-->
					<!--              &lt;!&ndash;              &nbsp;&ndash;&gt;-->
					<!--              &lt;!&ndash;              <img&ndash;&gt;-->
					<!--              &lt;!&ndash;                class="img-box-min"&ndash;&gt;-->
					<!--              &lt;!&ndash;                src="../../assets/images/img25.png"&ndash;&gt;-->
					<!--              &lt;!&ndash;                alt=""&ndash;&gt;-->
					<!--              &lt;!&ndash;              /><a&ndash;&gt;-->
					<!--              &lt;!&ndash;                :href="`${path}2.jpg`"&ndash;&gt;-->
					<!--              &lt;!&ndash;                download="项目评审表模板.jpg"&ndash;&gt;-->
					<!--              &lt;!&ndash;                style="color: #c73630"&ndash;&gt;-->
					<!--              &lt;!&ndash;                >项目评审表.png</a&ndash;&gt;-->
					<!--              &lt;!&ndash;              >&ndash;&gt;-->
					<!--            </div>-->
					<!--          </div>-->
					<!--<div v-if="!ishow && reviewShow === false">
						<a class="file flex flex-center align-items-center" >
							<input type="file" id="people-export" :disabled="!previewTimeout || loading" value="shancgahunwenjai " @change="onFileChange" @click="onFile" style="cursor: pointer" />
							<img v-if="fileName === null" class="img-box" src="../../assets/images/img26.png" alt="" />
							<img v-if="fileName !== null" class="img-box" src="../../assets/images/img26.png" alt="" />
							<span>{{
                !previewTimeout && fileName === null
                  ? "未上传文件"
                  : "评审意见"
              }}</span>
						</a>
					</div>-->


					<!--<div v-if="ishow">
						<a class="file flex flex-center align-items-center" @click="uploadReson">-->
					<!--<input type="file" id="people-export" :disabled="!previewTimeout || loading" value="shancgahunwenjai " @change="onFileChange" @click="onFile" style="cursor: pointer" />-->
					<!--<img v-if="fileName === null" class="img-box" src="../../assets/images/img26.png" alt="" />
							<img v-if="fileName !== null" class="img-box" src="../../assets/images/img26.png" alt="" />
							<span>评审意见</span>
						</a>
					</div>-->
					<!--ishow &&-->
					<!--<div v-if="previewTimeout" class="review" @click="review" >
			            <img src="@/assets/images/review.png" alt="" />
			            {{ reviewBtn }}
         			</div>-->
					<div class="file-list" v-if="fileName !== null" @click="previewFile(fileName1)">
						<a-tooltip>
							<template slot="title"> {{ fileName }} </template>
							<img class="img-box-min" src="../../assets/images/img25.png" alt="" /> {{ fileName }}
						</a-tooltip>
					</div>
					<!--<div class="num-box flex align-items-center">
						<div class="flex-1" style="text-align: center">当前分数 :</div>
						<input class="" :disabled="!previewTimeout" style="text-align: center; color: #9A0B00" v-model="evaluationData.score" type="text" />
					</div>
					<div class="submit-btn" @click="submitPreview" v-if="previewTimeout">
						提交
					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const EditableCell = {
	template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number :max="max" :min="0" :autoFocus="autoFocus":value="value" @change="handleChange" @mouseout="check" @pressEnter="check" @blur="check"/>
        </div>
        <div v-else class="editable-cell-text-wrapper" >
           <div v-if="evaluationTablePreview" style="width:100%;height:100%;display: flex;align-items: center;">	
            <span style="width:100%;"   >{{ value || ' ' }}</span>
           </div>
           <div v-else style="width:100%;height:32px;display: flex;align-items: center;" @mouseover="edit">	
            <span style="width:100%;"   >{{ value || ' ' }}</span>
           </div>
        </div>
      </div>
    `,
	props: {
		text: {
			type: String,
			default: '',
		},
		max: {
			type: Number,
			default: 0
		},
		evaluationTablePreview: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			value: this.text,
			editable: false,
			autoFocus: true,
		};
	},
	methods: {
		handleChange(value) {
			if (value > this.max) {
				this.$message.warn('输入得分超出对应分值,按对应分值最高分评分');
			}
			this.value = value;
		},
		check() {
			this.editable = false;
			this.$emit("change", this.value);
		},
		edit() {
			this.editable = true;
		},
	},
};

import { baseURL } from "@/utils/request.js";
import { fileUpdate, getAction, postAction } from "@/api/index";
import basicData from "../alApplyFileupload/basicData";
export default {
	name: "",
	components: {
		EditableCell,
		basicData
	},
	props: {
		preViewData: {
			type: Object,
		},
		type: String,
		previewTimeout: Boolean,
		evaluationTablePreview: {
			type: Boolean,
			default: false
		},
		// 允许父组件覆盖路由名判断(首页等非赛道页面传对应赛道名即可)
		routeName: {
			type: String,
			default: ""
		},
		// 仅展示教学视频(首页高职组/中职组作品弹窗用)
		videoOnly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			editInfoStep1: {},
			ishow: false,
			previewUrl: "/1.pdf",
			path: process.env.BASE_URL,
			previewType: "",
			title: "",
			fileList: null,
			fileTreeList: null,
			defaultGraph: false,
			fileName: null,
			fileName1: null,
			loading: false,
			fullscreen: false,
			evaluationData: {
				score: "",
				scoreFile: "",
				applyIds: [],
			},
			reviewBtn: '开始评审',
			applyType: '4',
			columns: [
				{
					title: "评价维度",
					dataIndex: "oneTarget",
					key: "oneTarget",
					align: "center",
					width: 120,
					scopedSlots: { customRender: "oneTarget" },
					customRender: (text, record, index) => {
						const obj = {
							children: record.oneTarget,
							attrs: {},
						}
						obj.attrs.rowSpan = this.columnsInit(record.oneTarget, this.reviewData.dataList, 'oneTarget', index)
						return obj
					},
				},
				{
					title: "评价指标",
					dataIndex: "twoTarget",
					key: "twoTarget",
					align: "center",
					width: 140,
				},
				{
					title: "评价要点",
					dataIndex: "content",
					key: "content",
					scopedSlots: { customRender: "content" },
					ellipsis: true,
					align: "center",
				},
				{
					title: "分值",
					dataIndex: "score",
					key: "score",
					width: 80,
					align: "center",
				},
				{
					title: "得分",
					dataIndex: "itemScore",
					key: "itemScore",
					align: "center",
					width: 120,
					scopedSlots: { customRender: "itemScore" },
				},
			],
			reviewData: {
				// 专家评语
				remark: "",
				// 指标数据
				dataList: [],
			},
			// 评审
			reviewShow: false,
			emptyPrompt: false,
			// 仅视频模式：无教学视频标记
			videoEmpty: false,
			targetTotalScore: 0,
			// 总得分
			totalPoints: 0,
		};
	},
	computed: {
		currentRouteName() {
			return this.routeName || this.$route.name;
		}
	},
	watch: {},
	created() {
		//			console.log(this.previewUrl);
		this.previewUrl = "../../static/pdfjs/web/viewer.html?file=" + this.previewUrl;
		//			console.log(this.previewUrl);
		this.editInfoStep1 = this.preViewData;
		//			console.log(document.getElementsByTagName("iframe"));
		if (this.$store.state.region == '5') {
			this.ishow = true;
		}
	},
	mounted() {
		//			console.log(document.getElementsByTagName("iframe"));
		this.evaluationData.applyIds.push(this.preViewData.id);
		this.editInfoStep1 = this.preViewData;
		if (this.$store.state.region == '5') {
			this.ishow = true;
			this.emptyPrompt = false;
		}
		if (this.preViewData && this.preViewData.score !== null && this.preViewData.score !== "-") {
			this.evaluationData.score = this.preViewData.score;
		}
		if (this.preViewData && this.preViewData.scoreFile !== null && this.preViewData.scoreFile !== "-") {
			let newName = this.preViewData.scoreFile.slice(
				this.preViewData.scoreFile.lastIndexOf("/") + 1
			);
			let firstname = newName.slice(0, newName.lastIndexOf("_"));
			let lastname = newName.slice(newName.lastIndexOf("."));
			this.fileName = firstname + lastname;
			this.fileName1 = newName;
			this.evaluationData.scoreFile = this.preViewData.scoreFile.slice(8);
		}
		if (
			this.preViewData &&
			this.preViewData.applyFiles &&
			this.preViewData.applyFiles.length > 0
		) {
			let treeFile = [];
			if (this.currentRouteName === "educationalBrand") {
				treeFile = [{
					title: "名班主任工作室建设方案",
					key: 7,
					children: [],
					hadThree: false,
				},
				{
					title: "名班主任工作室实录视频",
					key: 8,
					children: [],
					hadThree: false,
				},
				{
					title: this.preViewData.teacher1,
					key: 111,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				{
					title: this.preViewData.teacher2,
					key: 222,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				{
					title: this.preViewData.teacher3,
					key: 333,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				];
				for (let i = 0; i < treeFile.length; i++) {
					if (!treeFile[i].hadThree) {
						for (let j = 0; j < this.preViewData.applyFiles.length; j++) {
							if (treeFile[i].key == this.preViewData.applyFiles[j].fileType) {
								treeFile[i].children.push(this.preViewData.applyFiles[j]);
							}
						}
					} else {
						for (let l = 0; l < treeFile[i].children.length; l++) {
							for (let k = 0; k < this.preViewData.applyFiles.length; k++) {
								if (
									treeFile[i].children[l].key ==
									this.preViewData.applyFiles[k].fileType
								) {
									treeFile[i].children[l].children.push(
										this.preViewData.applyFiles[k]
									);
								}
							}
						}
					}
				}
			} else if (this.currentRouteName === "szStudio") {
				treeFile = [{
					title: "参赛教案",
					key: 1,
					children: [],
				},
				{
					title: "教学实施报告",
					key: 2,
					children: [],
				},
				{
					title: "专业人才培养方案",
					key: 3,
					children: [],
				},
				{
					title: "课程标准",
					key: 4,
					children: [],
				},
				{
					title: "成员一参赛作品视频材料",
					key: 5,
					children: [],
				},
				{
					title: "成员二参赛作品视频材料",
					key: 6,
					children: [],
				},
				{
					title: "成员三参赛作品视频材料",
					key: 7,
					children: [],
				},
				{
					title: "成员四参赛作品视频材料",
					key: 8,
					children: [],
				},
				];
				for (let i = 0; i < treeFile.length; i++) {
					treeFile[i].hadThree = false;
					for (let j = 0; j < this.preViewData.applyFiles.length; j++) {
						if (treeFile[i].key == this.preViewData.applyFiles[j].fileType) {
							treeFile[i].children.push(this.preViewData.applyFiles[j]);
						}
					}
				}
				console.log(treeFile);
			} else if (this.currentRouteName === "alApply") {
				//					console.log("111111111");
				treeFile = [
					{
						title: "基本信息",
						key: 11111,
						children: [],
					},
					{
						title: "教学视频",
						key: 1,
						children: [],
					},
					// {
					// 	title: "数字化典型小案例",
					// 	key: 9,
					// 	children: [],
					// },
					{
						title: "教学设计",
						key: 2,
						children: [],
					},
					{
						title: "微课逐字稿",
						key: 3,
						children: [],
					},
					{
						title: "联络人信息表",
						key: 4,
						children: [],
					},
					{
						title: "参赛作品汇总表",
						key: 5,
						children: [],
					},
					{
					title: "参赛作品推荐表",
					key: 6,
					children: [],
				},
				{
					title: "微课课件",
					key: 7,
					children: [],
				},
				{
					title: "参赛作品信息表",
					key: 8,
					children: [],
				},
			];
				for (let i = 0; i < treeFile.length; i++) {
					treeFile[i].hadThree = false;
					for (let j = 0; j < this.preViewData.applyFiles.length; j++) {
						if (treeFile[i].key == this.preViewData.applyFiles[j].fileType) {
							// this.preViewData.applyFiles[j].proviewPath=null;

							treeFile[i].children.push(this.preViewData.applyFiles[j]);
						}
					}
				}
			} else if (this.currentRouteName === "xal") {
				//					console.log("111111111");
				treeFile = [
					{
						title: "基本信息",
						key: 11111,
						children: [],
					},
					// {
					// 	title: "数字化典型案例",
					// 	key: 1,
					// 	children: [],
					// },
					{
						title: "数字化典型案例",
						key: 9,
						children: [],
					},
					{
						title: "典型案例报送申请表",
						key: 2,
						children: [],
					},
					// {
					// 	title: "佐证材料",
					// 	key: 3,
					// 	children: [],
					// },
				];
				for (let i = 0; i < treeFile.length; i++) {
					treeFile[i].hadThree = false;
					for (let j = 0; j < this.preViewData.applyFiles.length; j++) {
						if (treeFile[i].key == this.preViewData.applyFiles[j].fileType) {
							this.preViewData.applyFiles[j].proviewPath = null;

							treeFile[i].children.push(this.preViewData.applyFiles[j]);
						}
					}
				}
			}
			// console.log(treeFile);
			this.fileTreeList = treeFile;
			this.applyVideoOnly();
			console.log(this.fileTreeList, '111')
		} else {
			this.defaultGraph = true;
			let treeFile = [];
			if (this.currentRouteName === "educationalBrand") {
				treeFile = [{
					title: "名班主任工作室建设方案",
					key: 7,
					children: [],
					hadThree: false,
				},
				{
					title: "名班主任工作室实录视频",
					key: 8,
					children: [],
					hadThree: false,
				},
				{
					title: this.preViewData.teacher1,
					key: 111,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				{
					title: this.preViewData.teacher2,
					key: 222,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				{
					title: this.preViewData.teacher3,
					key: 333,
					children: [{
						title: "参赛教案",
						key: 1,
						children: [],
					},
					{
						title: "教学实施报告",
						key: 2,
						children: [],
					},
					{
						title: "专业人才培养方案",
						key: 3,
						children: [],
					},
					{
						title: "课程标准",
						key: 4,
						children: [],
					},
					{
						title: "成员一参赛作品视频材料",
						key: 5,
						children: [],
					},
					{
						title: "成员二参赛作品视频材料",
						key: 6,
						children: [],
					},
					{
						title: "成员三参赛作品视频材料",
						key: 7,
						children: [],
					},
					{
						title: "成员四参赛作品视频材料",
						key: 8,
						children: [],
					},
					],
					hadThree: true,
				},
				];
			} else if (this.currentRouteName === "szStudio") {
				treeFile = [{
					title: "参赛教案",
					key: 1,
					children: [],
				},
				{
					title: "教学实施报告",
					key: 2,
					children: [],
				},
				{
					title: "专业人才培养方案",
					key: 3,
					children: [],
				},
				{
					title: "课程标准",
					key: 4,
					children: [],
				},
				{
					title: "成员一参赛作品视频材料",
					key: 5,
					children: [],
				},
				{
					title: "成员二参赛作品视频材料",
					key: 6,
					children: [],
				},
				{
					title: "成员三参赛作品视频材料",
					key: 7,
					children: [],
				},
				{
					title: "成员四参赛作品视频材料",
					key: 8,
					children: [],
				},
				];
			} else if (this.currentRouteName === "alApply") {
				treeFile = [{
					title: "基本信息",
					key: 11111,
					children: [],
				},
				{
					title: "教学视频",
					key: 1,
					children: [],
				},
				// {
				// 	title: "数字化典型小案例",
				// 	key: 9,
				// 	children: [],
				// },
				{
					title: "教学设计",
					key: 2,
					children: [],
				},
				{
					title: "微课逐字稿",
					key: 3,
					children: [],
				},
				{
					title: "联络人信息表",
					key: 4,
					children: [],
				},
				{
					title: "参赛作品汇总表",
					key: 5,
					children: [],
				},
				{
					title: "参赛作品推荐表",
					key: 6,
					children: [],
				},
				{
					title: "微课课件",
					key: 7,
					children: [],
				},
				{
					title: "参赛作品信息表",
					key: 8,
					children: [],
				},
					// {
					// 	title: "佐证材料",
					// 	key: 3,
					// 	children: [],
					// },
				];
			} else if (this.currentRouteName === "xal") {
				treeFile = [{
					title: "基本信息",
					key: 11111,
					children: [],
				},
				// {
				// 	title: "数字化典型大案例",
				// 	key: 1,
				// 	children: [],
				// },
				{
					title: "数字化典型案例",
					key: 9,
					children: [],
				},
				{
					title: "典型案例报送申请表",
					key: 2,
					children: [],
				},
					// {
					// 	title: "佐证材料",
					// 	key: 3,
					// 	children: [],
					// },
				];
			}

			this.fileTreeList = treeFile;
			this.applyVideoOnly();
			console.log(this.fileTreeList, '222')
		}
		if (window.sessionStorage.getItem(`${this.preViewData.id}reviewData`)) {
			this.reviewBtn = "继续评审";
		} else {
			this.reviewBtn = "开始评审";
		}
	},
	methods: {
		getRef() {

		},
		review(type, index) {
			//			      this.reviewShow = true;
			//			      this.emptyPrompt = false;
			//			      this.defaultGraph = false;
			//			      this.ishow=false;
			//			      this.previewType = "";
			//			      if (window.sessionStorage.getItem(`${this.preViewData.id}reviewData`)) {
			//			        this.reviewData = JSON.parse(window.sessionStorage.getItem(`${this.preViewData.id}reviewData`));
			//			        this.targetTotalScore = 0
			//			        this.totalPoints = 0
			//			        this.reviewData.dataList.forEach((item) => {
			//			          this.targetTotalScore += item.score;
			//			          this.totalPoints += Number(item.itemScore);
			//			        });
			//			        if (!this.reviewData.hasOne) {
			//			          this.columns = this.columns.filter(
			//			            (item) => item.title != "评价维度"
			//			          );
			//			        }
			//			      } else {
			//			        this.getReviewTable(type,index);
			//			      }

			const currentUrl = window.location.origin + "/personalCenter/rateScore?id=" + this.preViewData.id + "&userid=" + this.$store.state.user.id;
			window.open(
				currentUrl, 'target'
			);
		},
		// 获取评审表格
		getReviewTable(type, index) {
			let params = {
				applyType: this.applyType,
				applyId: this.preViewData.id,
				expertUserId: this.$store.state.user.id,
			};
			if (type && type == 'reviewTable') {
				params.expertUserId = this.preViewData.expertApplys[index].expertUserId
			}
			getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
				if (res.code == 200) {
					this.reviewData = res.result;
					this.targetTotalScore = 0
					this.totalPoints = 0
					this.reviewData.dataList.forEach((item) => {
						this.targetTotalScore += item.score;
						this.totalPoints += Number(item.itemScore);
					});
					if (!this.reviewData.hasOne) {
						this.columns = this.columns.filter(
							(item) => item.title != "评价维度"
						);
					}
				}
			});
		},
		getFileName(name) {
			let newName = name.slice(name.lastIndexOf("/") + 1);
			let firstname = newName.slice(0, newName.lastIndexOf("_"));
			let lastname = newName.slice(newName.lastIndexOf("."));
			return firstname + lastname;
		},
		// 仅展示教学视频：过滤文件树只保留「教学视频」节点，并自动播放第一个视频
		applyVideoOnly() {
			if (!this.videoOnly) return;
			const vNode = (this.fileTreeList || []).find((n) => n.key === 1);
			this.fileTreeList = vNode ? [vNode] : [];
			const hasVideo = !!(vNode && vNode.children && vNode.children.length);
			this.videoEmpty = !hasVideo;
			if (hasVideo) {
				const first = vNode.children[0];
				const path = first.previewPath || first.filePath;
				if (path) {
					this.$nextTick(() => {
						this.onSelect([path], {
							selectedNodes: [],
							node: {},
						});
					});
				}
			}
		},
		onSelect(selectedKeys, { selectedNodes, node }) {
			console.log(selectedKeys,);
			if (typeof selectedKeys[0] === "string") {
				let fileName = selectedKeys[0].lastIndexOf(".");
				this.previewType = selectedKeys[0].substring(
					fileName + 1,
					selectedKeys[0].length
				);
				this.ishow = false;
				if (this.$store.state.region == '5') {
					// this.previewType='pdf';
					let selected = selectedKeys[0];
					// console.log();
					let sj = selected.substring(0, selected.lastIndexOf("."));
					// console.log(this.previewType, "5555");
					// console.log(sj, "6666");
					if (selectedKeys[0].indexOf('http://office.hxpxxy.com') != -1 || selectedKeys[0].indexOf('https://office.hxpxxy.com') != -1) {

						this.previewUrl = selectedKeys[0] + "?time=" + Math.random();
					} else {
						if (this.previewType === "doc" || this.previewType === "docx" || this.previewType === "ppt" || this.previewType === "pptx" || this.previewType === "xls" || this.previewType === "xlsx") {
							sj = sj + ".pdf";
							this.previewUrl = baseURL + sj + "?time=" + Math.random();
						} else {
							this.previewUrl = baseURL + selected + "?time=" + Math.random();
						}
					}

					//						this.previewUrl = "/pdfjs/web/viewer.html?file="+this.previewUrl;
					this.reviewShow = false;
					return false;
				}
				// if(this.previewType === "doc" || this.previewType === "docx") {
				// 	this.previewUrl = selectedKeys[0];
				// } else {
				// 	this.previewUrl = baseURL + selectedKeys[0];
				// }

			} else if (selectedKeys.length == '0' && selectedNodes.length == '0' && this.$store.state.role == 'expert-role') {
				if (this.ishow) {
					this.previewType = '';
				}
				this.ishow = false;
			} else {
				if (this.currentRouteName == 'alApply' && selectedKeys[0] == 11111) {
					this.ishow = true;
					this.previewType = '';
				} else if (this.currentRouteName == 'xal' && selectedKeys[0] == 11111) {
					this.ishow = true;
					this.previewType = '';
				}
				node.onExpand();
			}
			this.reviewShow = false;
		},
		goNewPage() {
			let element = document.documentElement;
			if (this.fullscreen) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			} else {
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();
				}
			}
			this.fullscreen = !this.fullscreen;
			this.$emit("goNewPage", this.fullscreen);
		},
		transform(text) {
			return String(text).replaceAll("\\n", "\n");
		},
		onFileChange(e) {
			if (!this.loading) {
				this.loading = true;
				if (e && e.target && e.target.files) {
					let fileSize = e.target.files[0].size > 1024 * 1024 * 500;
					if (!fileSize) {
						this.fileName = "文件上传中...";
						const formData = new FormData();
						formData.append("file", e.target.files[0]);
						formData.append("biz", "linxuan");
						fileUpdate(formData).then((res) => {
							if (res.code === 0) {
								this.$message.success("上传成功");
								this.evaluationData.scoreFile = res.message;
								let newName = res.message.slice(
									res.message.lastIndexOf("/") + 1
								);
								let firstname = newName.slice(0, newName.lastIndexOf("_"));
								let lastname = newName.slice(newName.lastIndexOf("."));
								this.fileName = firstname + lastname;
								this.fileName1 = newName;
								this.loading = false;
								if (this.fullscreen) {
									this.goNewPage();
								}
							} else {
								this.$message.error("上传失败");
							}
						});
					} else {
						this.$message.error("请上传小于 500M 的文件");
					}
				} else {
					return;
				}
			} else {
				this.$message.error("文件上传中");
			}
		},
		uploadReson() {
			this.$emit("openReson", true);
		},
		previewFile(name) {
			this.previewUrl = baseURL + "linxuan/" + name;
			let lastname = name.lastIndexOf(".");
			this.previewType = name.substring(lastname + 1, name.length);
		},
		closePreview() {
			this.$emit("closePreview");
			if (this.fullscreen) {
				this.goNewPage();
			}
		},
		downLoadFile() {
			// window.open(this.previewUrl);
		},
		onFile() {
			console.log(this.fullscreen);
			if (this.fullscreen) {
				this.goNewPage();
			} else {

			}
		},
		onCellChange(key, dataIndex, value) {
			const dataSource = [...this.reviewData.dataList];
			const target = dataSource.find((item) => item.id === key);
			if (target) {
				target[dataIndex] = value;
				this.reviewData.dataList = dataSource;
			}
			this.totalPoints = 0;
			this.reviewData.dataList.forEach((item) => {
				this.totalPoints += Number(item.itemScore);
			});
			window.sessionStorage.setItem(
				`${this.preViewData.id}reviewData`,
				JSON.stringify(this.reviewData)
			);
		},
		// 评审提交
		submit() {
			let map = {};
			this.reviewData.dataList.forEach((item) => {
				map[item.id] = Number(item.itemScore);
			});
			let params = {
				itemScores: map,
				applyId: this.preViewData.id,
				remark: this.reviewData.remark,
			};
			postAction("/lx/lxExpertItem/settingScore", params).then((res) => {
				if (res.code == 200) {
					this.$message.success("提交成功");
					this.$emit("submitPreview");
					window.sessionStorage.removeItem(`${this.preViewData.id}reviewData`);
				}
			});
		},
		// 合并单元格
		columnsInit(text, data, key, index) {
			if (index !== 0 && text == data[index - 1][key]) {
				return 0
			}
			let rowSpan = 1 //判断下一行是否相等
			for (let i = index + 1; i < data.length; i++) {
				if (text !== data[i][key]) {
					break
				}
				rowSpan++
			}
			return rowSpan
		},
		// 专家评语输入
		remarkChange() {
			window.sessionStorage.setItem(
				`${this.preViewData.id}reviewData`,
				JSON.stringify(this.reviewData)
			);
		},
		submitPreview() {
			// if (this.evaluationData.scoreFile === "") {
			//   this.$message.error("请上传评审文件");
			//   return false;
			// }
			// if (this.evaluationData.score === "") {
			//   this.$message.error("请输入评审分数");
			//   return false;
			// }
			if (this.loading) {
				this.$message.error("评审文件上传中");
				return false;
			}
			if (this.fullscreen) {
				this.goNewPage();
			}
			this.$emit("submitPreview", this.evaluationData);
		},
	},
};
</script>

<style scoped lang="scss">
.img-box {
	width: 15px;
	height: 17px;
	margin-right: 8px;
}

.img-box-min {
	width: 10px;
	height: 12px;
	margin-right: 8px;
}

.c-box {
	width: 100%;
	height: 100%;
	background: url("../../assets/images/img19.png") no-repeat;
	background-size: 100% 100%;
}

.c-box-fullscreen {
	width: 100%;
	height: 100%;
	background: #fff;
	/* background: url("../../assets/images/img19.png") no-repeat;
  background-size: 100% 100%;*/
}

.header-box-fullscreen {
	height: 80px;
	line-height: 78px;
	position: relative;
	text-align: center;
	background: #9A0B00;
	font-size: 28px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #fff;
}

.header-box {
	height: 80px;
	line-height: 78px;
	position: relative;
	text-align: center;
	background: #9A0B00;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
	margin: 0px 19px 0px 9px;
	font-size: 28px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #fff;
}

.bottom-evaluate {
	margin-top: 12px;

	.num-box {
		height: 35px;
		margin-bottom: 18px;
		border-radius: 10px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #c73630;
		background: #ffe4de;

		input {
			border: none;
			padding: 0 15px;
			width: 155px;
			height: 22px;
			margin-right: 8px;
			border-radius: 6px;
			color: #383838;
		}
	}
}

.centent-box {
	margin: 0 12px 5px 0;
	padding: 10px 25px;
	height: 80%;

	.left-preview-box {
		position: relative;
		height: 100%;

		.review-content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 100%;
			padding-bottom: 10px;
			overflow-y: auto;

			.table {
				/deep/ .ant-table-thead>tr>th {
					font-size: 18px !important;
				}

				/deep/ .ant-table-tbody>tr>td {
					font-size: 18px;
				}
			}
		}

		.target-score {
			margin-top: 10px;
			color: #6c6c6c;
			text-align: right;
			font-size: 16px;

			.number {
				font-size: 20px;
				color: #9A0B00;
			}

			.score {
				color: #9A0B00;
			}
		}

		.expertReviews-title {
			font-size: 18px;
			color: #000;
		}

		.expertReviews-title:before {
			display: inline-block;
			width: 6px;
			height: 22px;
			background: #9A0B00;
			border-radius: 5px;
			content: "";
			/**
			    这个指为正的话 小方块就往上， 为负的话，小方块就往下
			    */
			vertical-align: middle;
			margin-right: 6px;
		}

		.remark-input {
			margin-top: 20px;
			resize: none;
			font-size: 16px;
		}

		.submit {
			width: 263px;
			height: 41px;
			background: #9A0B00;
			border-radius: 8px;
			line-height: 41px;
			text-align: center;
			margin: 0 auto;
			color: #ffffff;
			margin-top: 30px;
			font-size: 16px;
			cursor: pointer;
		}
	}

	.right-filelist-box {
		width: 237px;
		height: 100%;
		padding-bottom: 10px;
		margin-left: 20px;

		.top-filelist {
			background: #f8f9ff;
			padding: 15px 10px;
			overflow-y: auto;
		}

		.top-filelist::-webkit-scrollbar {
			display: none;
		}

		.bottom-evaluate {
			margin-top: 12px;

			.num-box {
				height: 35px;
				margin-bottom: 18px;
				border-radius: 10px;
				font-size: 16px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #9A0B00;
				background: #b7d1ff;

				input {
					border: none;
					padding: 0 15px;
					width: 155px;
					height: 22px;
					margin-right: 8px;
					border-radius: 6px;
					color: #383838;
				}
			}
		}

		.submit-btn {
			height: 35px;
			line-height: 35px;
			text-align: center;
			cursor: pointer;
			background: #9A0B00;
			border-radius: 10px;
			margin-bottom: 10px;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #ffffff;
		}

		.review {
			width: 237px;
			height: 60px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid #9A0B00;
			border-radius: 8px;
			font-size: 16px;
			font-weight: bold;
			color: #9A0B00;
			text-align: center;
			line-height: 60px;
			cursor: pointer;
		}
	}
}

.file {
	position: relative;
	width: 100%;
	height: 35px;
	background: #fff;
	border: 1px solid #9A0B00;
	border-radius: 10px;
	padding: 4px 12px;
	overflow: hidden;
	color: #575757;
	text-decoration: none;
	text-indent: 0;
	line-height: 35px;
	margin-bottom: 8px;
	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: 400;
}

.file input {
	position: absolute;
	font-size: 100px;
	right: 0;
	top: 0;
	opacity: 0;
}

.file:hover {
	background: rgba(218, 218, 218, 0.2);
	color: #000;
	text-decoration: none;
}

.img-preview-box {
	position: relative;
	max-height: 718px;
	overflow: hidden;
	height: 100%;
	background: #000;
}

.img-preview-box-fullscreen {
	position: relative;
	overflow: hidden;
	height: 100%;
	background: #000;
}

.img-preview {
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.close-box {
	position: absolute;
	color: #fff;
	font-size: 40px;
	right: 3%;
	cursor: pointer;
	top: -2px;
}

.submit-btn-disabled {
	opacity: 0.6;
	cursor: no-drop !important;
}

.file-list {
	margin: 10px 0;
	padding: 0 15px;
	overflow: hidden;
	cursor: pointer;
	white-space: nowrap;
}

.file-list:hover {
	color: #9A0B00;
}

.bg-img-box {
	background: url("~@/assets/images/img53.png") no-repeat;
	background-size: 100% 100%;
}

.fullScreen {
	color: #fff;
	position: absolute;
	right: 7%;
	top: 2px;
	z-index: 99;
	cursor: pointer;
}

.icon-style {
	font-size: 25px;
}

.msg-box {
	position: absolute;
	top: 20%;
	left: 50%;
	transform: translate(-50%, -20%);
	text-align: center;
}

.pdf-wrap {
	position: relative;
}

/deep/ .editable-cell-text-wrapper {
	width: 40%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	padding: 0px 0px;
	border-bottom: 2px solid #9A0B00;
	box-sizing: border-box;
}
</style>
<style>
.top-filelist .ant-tree-title {
	display: inline-block;
	width: 190px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.top-filelist .ant-tree li .ant-tree-node-content-wrapper {
	display: inline-block;
	width: 190px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>